enum ActionType {
  MODAL_SET = 'MODAL_SET',
  MODAL_UNSET = 'MODAL_UNSET',
  MODAL_SET_PROPS = 'MODAL_SET_PROPS',
}

export default ActionType;
